import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cr_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const adminToken = localStorage.getItem('cr_admin_token');
      const adminUser = localStorage.getItem('cr_admin_user');
      if (adminToken && adminUser) {
        localStorage.setItem('cr_token', adminToken);
        localStorage.setItem('cr_user', adminUser);
        localStorage.removeItem('cr_admin_token');
        localStorage.removeItem('cr_admin_user');
        window.location.href = '/admin';
      } else {
        localStorage.removeItem('cr_token');
        localStorage.removeItem('cr_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
